module.exports = __webpack_public_path__ + "static/media/course_ai.55903801.svg";